import React, { useMemo, useState } from 'react'
// import PropTypes from 'prop-types'
import ReactCodeInput from 'react-code-input/dist/ReactCodeInput'
// import { validateEmailVerificationCodeAPICall } from '../../../apis/email-verification'
// import { EMAIL_VERIFICATION_CODE_LENGTH } from '../../../config/form-settings'
// import StepsWrapper from '../partials/stepsWrapper.jsx'
import StepsWrapper from '../partials/stepsWrapper.jsx'
import AuthService from '../services/AuthService'

import PropTypes from 'prop-types'
import Countdown, { zeroPad } from 'react-countdown'
import { Typography, Button } from 'antd'
import { withRouter } from 'react-router'
import { connect } from 'formik'
import { CONNECT_APP_URL, PRE_SIGNUP_SUBSCRIPTION_KEY, SEND_EMAIL_VERIFICATION_CODE_ENDPOINT, VERIFY_EMAIL_VERIFICATION_CODE_ENDPOINT } from '../config/constants.js'
import { triggerFormLevelValidation } from '../utils/formik.js'
import { errorNotification } from '../utils/helpers.js'
import { validateEmailVerificationCodeAPICall } from '../apis/email-verification.js'

const { Title, Paragraph } = Typography


const renderer = ({ minutes, seconds, completed }) => {
  if (completed) {
    return (
      <span>
        {zeroPad(minutes)}:{zeroPad(seconds)}
      </span>
    )
  } else {
    return (
      <span>
        {zeroPad(minutes)}:{zeroPad(seconds)}
      </span>
    )
  }
}

function VerificationForm ({ history, formik, onResendCode, handleSubmit, onSuccess }) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [disableForm, setDisableForm] = useState(false)
  const [countdownKey, setCountdownKey] = useState(1)
  const {
    name, email, phonePrefix, phone, password, role
  } = formik.values

  const countdown = useMemo(() => (
    <Countdown key={countdownKey} date={Date.now() + 300000} renderer={renderer} onComplete={() => setDisableForm(true)}/>
    // eslint-disable-next-line
  ), [countdownKey])

  const resendCode =  async () =>{
    setCountdownKey(countdownKey+1)
    setDisableForm(false)
    try {
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Ocp-Apim-Subscription-Key': PRE_SIGNUP_SUBSCRIPTION_KEY
        },
        body: JSON.stringify({ email })
      }
      const response = await window.fetch(SEND_EMAIL_VERIFICATION_CODE_ENDPOINT, config)
      const responseOk = await response.status === 200
      if(!responseOk){
        throw new Error('An error occured. Please try again.')
      }
    } catch (e) {
      errorNotification(e.message)
      console.error('ERROR: ', e)
    }
  }

  const handleOnChange = (verificationCode) => {
    triggerFormLevelValidation(formik, async () => {
      if (verificationCode.length === 6) {
        const responseOk = await validateEmailVerificationCodeAPICall(email, verificationCode)

          if (responseOk) {
            const auth = new AuthService()
            const formattedData = {
              email: email,
              password: password,
              name: name,
              user_metadata: {
                name: name,
                phone_number: phone,
                prefix: phonePrefix,
                user_type: role,
                Title: '',
                home_facility: '',
                specialty: '',
                signature: '',
                country: ''
              }
            }
            auth.signUp(formattedData, (err, response) => {
              if (err) {
                if (err.code === 'user_exists') {
                  errorNotification('We already have a user with the provided email address. Please login or try again with a different email.')
                  setTimeout(()=>{
                    window.location.href=CONNECT_APP_URL
                  },1500)
                } else {
                  errorNotification('Failed to create user')
                  history.replace('/')
                }
              } else {
                formik.setFieldValue('auth0Id', `auth0|${response.Id}`)
                auth.login(email, password, '/update/profile')

              }
            })
          } else{
            errorNotification('Email verification failed. Please try again.')
          }
      }
    })
  }




  return (
    <div className="verification-email">
      <StepsWrapper current="0">
      <Title level={2} className='text-capitalize'>Verification Required</Title>
      <div style={{marginTop:24}}>
        <Title level={4}>Please check your email</Title>
      </div>
      <div style={{marginTop:16}}>
        <Paragraph>
          We’ve sent a 6-digit verifcation code to {email}. It will expire in 5 minutes.
        </Paragraph>
      </div>

          <div style={{marginTop:35, fontSize: 38, color:'#15A9E1', fontFamily:'Roboto, sans-serif'}}>
            {countdown}
          </div>
          <div style={{marginTop:35}}>
            <ReactCodeInput
              className="verification-code-field"
              autoFocus={true}
              type="text"
              fields={6}
              name="verification"
              disabled={disableForm}
              onChange={handleOnChange}
            />
          </div>
          <div style={{marginTop:24}}>
            Haven’t received our email? Check your spam folder.
          </div>
          <div style={{marginTop:24, fontSize:18 }} className='text-capitalize'>
            <Button style={{padding:0}} type="link" onClick={resendCode}>Resend Verification Code</Button>
          </div>
          </StepsWrapper>
    </div>
  )
}

const { string, func } = PropTypes

VerificationForm.propTypes = {
  email: string,
  onResendCode: func,
  handleSubmit: func
}

export default connect(withRouter(VerificationForm))
